/*
 * Filename: onLoad-invoke-rule.controller.ts
 * Description: Controller for onload invoke action rule
 */

import { CQAppConstant } from '../../../app-constants';


export class CQOnLoadInvokeActionRuleController {
   
     // public targetFieldApiName = '';
    // public fields: string[] = [];
    // public filter = '';
    public ruleJSON: any = {};

    constructor(ruleObject: any) {
        this.formRuleJson(ruleObject);
    }

    /**
     * @private
     * @memberof CQOnInitInvokeActionRuleController
     */
    private formRuleJson = (invokeActionRuleData: any) => {
        
        const actions = invokeActionRuleData.actions.map((action:any)=> action.action );
        const componentRule: any = CQAppConstant.COMPONENT_EVENT_RULES_MAP;
        this.ruleJSON = {
            [componentRule.onLoadInvoke.key]: { onLoad: { 'invoke': { action: actions} } }
        };
        return this.formRuleJson;
    }
}

